var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlueVerticleStrip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 16.01 67.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-14,.cls-2{opacity:0.42;}.cls-2{fill:url(#linear-gradient-2);}.cls-3{fill:url(#linear-gradient-3);}.cls-4{fill:url(#linear-gradient-4);}.cls-5{fill:#39404f;}.cls-17,.cls-18,.cls-19,.cls-25,.cls-26,.cls-6,.cls-7,.cls-8{opacity:0.59;}.cls-6{fill:url(#linear-gradient-5);}.cls-7{fill:url(#linear-gradient-6);}.cls-8{fill:url(#linear-gradient-7);}.cls-9{fill:#353739;}.cls-10{fill:url(#linear-gradient-8);}.cls-11{fill:url(#linear-gradient-9);}.cls-12{fill:url(#linear-gradient-10);}.cls-13{fill:url(#linear-gradient-11);}.cls-14{fill:url(#linear-gradient-12);}.cls-15{fill:url(#linear-gradient-13);}.cls-16{fill:url(#linear-gradient-14);}.cls-17{fill:url(#linear-gradient-15);}.cls-18{fill:url(#linear-gradient-16);}.cls-19{fill:url(#linear-gradient-17);}.cls-20{fill:url(#linear-gradient-18);}.cls-21{fill:url(#linear-gradient-19);}.cls-22{fill:url(#linear-gradient-20);}.cls-23{fill:url(#linear-gradient-21);}.cls-24{fill:url(#linear-gradient-22);}.cls-25{fill:url(#linear-gradient-23);}.cls-26{fill:url(#linear-gradient-24);}.cls-27{fill:#4866a0;}.cls-28{fill:#24295a;}.cls-29{fill:url(#linear-gradient-25);}.cls-30{fill:url(#linear-gradient-26);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -825.34,
    y1: 145.64,
    x2: -809.33,
    y2: 145.64,
    gradientTransform: "matrix(1, 0, 0, -1, 825.34, 202.67)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2f2f80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#323685"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#4872af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#5189bf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#4d81b7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#426aa1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#31457c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#18124b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#18114a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -809.92,
    y1: 158.69,
    x2: -809.92,
    y2: 136.24,
    gradientTransform: "matrix(1, 0, 0, -1, 825.34, 202.67)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dee6f1",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4560a1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -824.77,
    y1: 150.21,
    x2: -809.55,
    y2: 134.99,
    gradientTransform: "matrix(1, 0, 0, -1, 825.34, 202.67)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#84caf0",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#84caf0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#84caf0",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#84caf0",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#84caf0",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#84caf0",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84caf0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -824.67,
    y1: 160.46,
    x2: -824.67,
    y2: 150.51,
    gradientTransform: "matrix(1, 0, 0, -1, 825.34, 202.67)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#84caf0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84caf0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -822.74,
    y1: 153.87,
    x2: -821.7,
    y2: 153.87,
    gradientTransform: "matrix(1, 0, 0, -1, 825.34, 202.67)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4e576b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#50596d",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#566076",
    stopOpacity: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#5a657d",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5d6881",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#5e6982",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#5d6881",
    stopOpacity: 0.07
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#5a657d",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#566076",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#50596e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 1114.06,
    y1: -1662.42,
    x2: 1114.86,
    y2: -1662.42,
    gradientTransform: "matrix(-0.69, 0.72, 0.72, 0.69, 1980.36, 397.22)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -813.09,
    y1: 148.83,
    x2: -811.9,
    y2: 148.83,
    gradientTransform: "matrix(1, 0, 0, -1, 825.34, 202.67)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#363d49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#404857",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#505a6f",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#5a657d",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#5e6982",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#5a647c",
    stopOpacity: 0.11
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#4e576b",
    stopOpacity: 0.41
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#3a424f",
    stopOpacity: 0.89
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#363d49"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 41.76,
    y1: 1287.67,
    x2: 41.76,
    y2: 1286.34,
    gradientTransform: "translate(1298.56 10.76) rotate(90)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#231f20",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231f20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 1036.13,
    y1: -1698.42,
    x2: 1036.13,
    y2: -1699.76,
    gradientTransform: "translate(1703.47 1084.63) rotate(-90)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: -816.37,
    y1: 97.99,
    x2: -817.49,
    y2: 96.87,
    gradientTransform: "matrix(1, 0, 0, -1, 825.34, 151.7)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#231f20",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#231f20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: -825.3,
    y1: -814.93,
    x2: -809.3,
    y2: -814.93,
    gradientTransform: "translate(825.3 825.65)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: -809.89,
    y1: -801.31,
    x2: -809.89,
    y2: -822.75,
    gradientTransform: "translate(825.3 825.65)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: -824.73,
    y1: -810.36,
    x2: -809.51,
    y2: -825.58,
    gradientTransform: "translate(825.3 825.65)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: -824.63,
    y1: -799.78,
    x2: -824.63,
    y2: -810.28,
    gradientTransform: "translate(825.3 825.65)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: -822.76,
    y1: -806.7,
    x2: -821.57,
    y2: -806.7,
    gradientTransform: "translate(825.3 825.65)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4e576b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#50596d",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#566076",
    stopOpacity: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#5a657d",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5d6881",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#5e6982",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#545e74",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#50596e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 1809.04,
    y1: -999.38,
    x2: 1809.85,
    y2: -999.38,
    gradientTransform: "translate(1980.36 631.07) rotate(-133.65)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: -813.02,
    y1: -811.74,
    x2: -811.87,
    y2: -811.74,
    gradientTransform: "translate(825.3 825.65)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#363d49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#404857",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#505a6f",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#5a657d",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#5e6982",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#5a647c",
    stopOpacity: 0.11
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#4e576b",
    stopOpacity: 0.41
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#3a424f",
    stopOpacity: 0.89
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#363d49"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 951.29,
    y1: 1287.72,
    x2: 951.29,
    y2: 1286.34,
    gradientTransform: "matrix(0, -1, -1, 0, 1298.6, 966.52)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 126.54,
    y1: -1698.35,
    x2: 126.54,
    y2: -1699.69,
    gradientTransform: "matrix(0, 1, 1, 0, 1703.43, -107.28)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: -816.2,
    y1: -811.5,
    x2: -817.42,
    y2: -812.72,
    gradientTransform: "translate(825.3 825.65)",
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 1042.97,
    y1: -1688.39,
    x2: 1042.97,
    y2: -1690.98,
    gradientTransform: "translate(1704.4 1076.86) rotate(-90)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#202b5c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#263566"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2d4172"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 1042.97,
    y1: -1701.87,
    x2: 1042.97,
    y2: -1704.4,
    gradientTransform: "translate(1704.4 1076.86) rotate(-90)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#344f94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#344d92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#31428a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: -813.09,
    y1: 168.79,
    x2: -811.9,
    y2: 168.79,
    gradientTransform: "matrix(1, 0, 0, -1, 825.34, 202.67)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#363d49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#404857",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#505a6f",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#5a657d",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#5e6982",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#5a647c",
    stopOpacity: 0.11
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#4e576b",
    stopOpacity: 0.41
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#3a424f",
    stopOpacity: 0.89
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#363d49"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: -822.79,
    y1: 168.79,
    x2: -821.69,
    y2: 168.79,
    gradientTransform: "matrix(1, 0, 0, -1, 825.34, 202.67)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4e576b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#50596d",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#566076",
    stopOpacity: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#5a657d",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#5d6881",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#5e6982",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#5d6881",
    stopOpacity: 0.07
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#5a657d",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#566076",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#50596e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 1050.75,
    y1: -1698.42,
    x2: 1050.75,
    y2: -1699.76,
    gradientTransform: "translate(1703.47 1084.63) rotate(-90)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 1050.72,
    y1: 1021.02,
    x2: 1050.72,
    y2: 1019.64,
    gradientTransform: "matrix(0, -1, -1, 0, 1031.9, 1084.6)",
    xlinkHref: "#linear-gradient-8"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "WATER-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Left_Frame",
    "data-name": "Left Frame"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outer_Frame",
    "data-name": "Outer Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Base",
    className: "cls-1",
    d: "M0,46.31V53a.43.43,0,0,0,.14.32L15.26,67.63a.44.44,0,0,0,.75-.32v-21Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Right_SD",
    "data-name": "Right SD",
    className: "cls-2",
    d: "M16,67a1.21,1.21,0,0,1,0,.5,1.42,1.42,0,0,1-.19.18l-1-2.32V46.31H16Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Top_HL",
    "data-name": "Top HL",
    className: "cls-3",
    d: "M14.81,65.37,1.34,52.31,0,53s0,.21.07.26c.31.27.65.61.65.61l14,13.19a4.83,4.83,0,0,0,.66.6.39.39,0,0,0,.45,0Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Left_HL",
    "data-name": "Left HL",
    className: "cls-4",
    points: "1.34 52.31 0 53.03 0 46.31 1.34 46.31 1.34 52.31"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Inner_Frame",
    "data-name": "Inner Frame"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Base-2",
    "data-name": "Base",
    className: "cls-5",
    points: "2.52 46.31 2.54 51.29 13.41 61.38 13.41 46.31 2.52 46.31"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Left_SD",
    "data-name": "Left SD",
    className: "cls-6",
    points: "3.71 46.31 3.71 50.68 2.54 51.29 2.52 46.31 3.71 46.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Top_SD",
    "data-name": "Top SD",
    className: "cls-7",
    points: "13.4 61.38 2.53 51.29 3.71 50.68 12.23 58.73 13.4 61.38"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Right_SD-2",
    "data-name": "Right SD",
    className: "cls-8",
    points: "12.23 46.31 12.23 58.73 13.41 61.38 13.41 46.31 12.27 46.31"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Base-3",
    "data-name": "Base"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-9",
    points: "12.23 46.31 12.23 58.73 3.71 50.68 3.71 46.31 12.23 46.31"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Bottom",
    className: "cls-10",
    points: "10.89 55.63 10.89 46.31 12.23 46.31 12.23 58.73 10.89 55.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Top",
    className: "cls-11",
    points: "5.04 46.31 5.04 49.89 3.71 50.68 3.71 46.31 5.04 46.31"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-12",
    points: "12.23 58.73 3.71 50.68 5.04 49.89 10.89 55.63 12.23 58.73"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Right_Frame",
    "data-name": "Right Frame"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outer_Frame-2",
    "data-name": "Outer Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Base-4",
    "data-name": "Base",
    className: "cls-13",
    d: "M0,21.44V14.72a.43.43,0,0,1,.14-.32L15.26.12A.45.45,0,0,1,16,.45v21Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Right_SD-3",
    "data-name": "Right SD",
    className: "cls-14",
    d: "M16,.74a1.16,1.16,0,0,0,0-.49,1,1,0,0,0-.19-.18l-1,2.32V21.44H16Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Top_HL-2",
    "data-name": "Top HL",
    className: "cls-15",
    d: "M14.81,2.39,1.34,15.44,0,14.72s0-.2.07-.26c.31-.27.65-.61.65-.61L14.68.67a4.25,4.25,0,0,1,.66-.6.39.39,0,0,1,.45,0Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Left_HL-2",
    "data-name": "Left HL",
    className: "cls-16",
    points: "1.34 15.44 0 14.72 0 21.44 1.34 21.44 1.34 15.44"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Inner_Frame-2",
    "data-name": "Inner Frame"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Base-5",
    "data-name": "Base",
    className: "cls-5",
    points: "2.52 21.44 2.54 16.47 13.41 6.37 13.41 21.44 2.52 21.44"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Left_SD-2",
    "data-name": "Left SD",
    className: "cls-17",
    points: "2.52 21.44 2.54 16.47 3.74 17.07 3.74 21.44 2.52 21.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Top_SD-2",
    "data-name": "Top SD",
    className: "cls-18",
    points: "13.41 6.37 2.53 16.47 3.73 17.07 12.26 9.02 13.41 6.37"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Right_SD-4",
    "data-name": "Right SD",
    className: "cls-19",
    points: "12.26 21.44 12.26 9.02 13.41 6.37 13.41 21.44 12.27 21.44"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-2",
    "data-name": "Fill"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Base-6",
    "data-name": "Base"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-9",
    points: "12.26 21.44 12.26 9.02 3.75 17.07 3.74 21.44 12.26 21.44"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Bottom-2",
    "data-name": "Bottom",
    className: "cls-20",
    points: "10.9 12.35 10.88 21.44 12.26 21.44 12.26 9.02 10.9 12.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Top-2",
    "data-name": "Top",
    className: "cls-21",
    points: "5.08 21.44 5.08 17.86 3.74 17.07 3.74 21.44 5.08 21.44"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-22",
    points: "12.26 9.02 3.74 17.07 5.08 17.86 10.9 12.35 12.26 9.02"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Center_Bars",
    "data-name": "Center Bars"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 13.41,
    y: 21.21,
    width: 2.6,
    height: 25.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    y: 21.21,
    width: 2.52,
    height: 25.34
  }), /*#__PURE__*/React.createElement("g", {
    id: "Inner_Bars",
    "data-name": "Inner Bars"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M13.41,46.54V21.21m-10.89,0V46.55M13.41,21.21H12.26l0,17.46v7.88h1.18M3.74,21.21H2.52V46.55H3.71Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Right_SD-5",
    "data-name": "Right SD",
    className: "cls-25",
    points: "13.41 21.21 13.41 46.55 12.23 46.55 12.26 21.21 13.41 21.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Left_SD-3",
    "data-name": "Left SD",
    className: "cls-26",
    points: "3.74 21.21 3.71 46.55 2.52 46.55 2.52 21.21 3.74 21.21"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Left_HL-3",
    "data-name": "Left HL",
    className: "cls-27",
    y: 21.21,
    width: 1.34,
    height: 25.33
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Left_HL-4",
    "data-name": "Left HL",
    className: "cls-28",
    x: 14.81,
    y: 21.21,
    width: 1.18,
    height: 25.33
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-3",
    "data-name": "Fill"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Base-7",
    "data-name": "Base",
    className: "cls-9",
    points: "12.26 21.21 3.74 21.21 3.71 46.55 12.23 46.55 12.26 21.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Left_SD-4",
    "data-name": "Left SD",
    className: "cls-29",
    points: "5.04 21.21 5.04 46.55 3.71 46.55 3.74 21.21 5.04 21.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Right_SD-6",
    "data-name": "Right SD",
    className: "cls-30",
    points: "10.88 21.21 10.88 46.55 12.23 46.55 12.26 21.21 10.88 21.21"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueVerticleStrip);
export default __webpack_public_path__ + "static/media/blueVerticleStrip.41d10b5a7218a98cc723d36d075e7a56.svg";
export { ForwardRef as ReactComponent };